import { doc, updateDoc, getDoc, Timestamp } from 'firebase/firestore';
import { db, appId } from '../config/firebase';
import { toDateObj } from '../utils/helpers';

const SRS_INTERVALS = [1, 3, 7, 14, 30];

export const getSRSStatus = (article) => {
    if (!article.nextReviewDate) return { color: "bg-slate-100 text-slate-500 border-slate-200 dark:bg-slate-700 dark:text-slate-300 dark:border-slate-600", text: "新文章", days: 0 };
    const now = new Date();
    const reviewDate = toDateObj(article.nextReviewDate);
    const diffTime = reviewDate - now;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    if (diffDays <= 0) return { color: "bg-rose-100 text-rose-600 border-rose-200 dark:bg-rose-900/30 dark:text-rose-400 dark:border-rose-800", text: "現在", days: 0 };
    const idx = article.srsIntervalIndex;
    if (idx >= 4) return { color: "bg-green-100 text-green-600 border-green-200 dark:bg-green-900/30 dark:text-green-400 dark:border-green-800", text: `${diffDays} 天後`, days: diffDays };
    if (idx >= 2) return { color: "bg-blue-100 text-blue-600 border-blue-200 dark:bg-blue-900/30 dark:text-blue-400 dark:border-blue-800", text: `${diffDays} 天後`, days: diffDays };
    return { color: "bg-slate-100 text-slate-500 border-slate-200 dark:bg-slate-700 dark:text-slate-300 dark:border-slate-600", text: `${diffDays} 天後`, days: diffDays };
};

export const updateArticleSRS = async (articleId, accuracy, user, localData, saveLocalData) => {
    let currentIntervalIndex = -1;
    let article = null;

    // Fetch current article state
    if (user) {
        try {
            const docRef = doc(db, 'artifacts', appId, 'users', user.uid, 'articles', articleId);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                article = docSnap.data();
                currentIntervalIndex = article.srsIntervalIndex !== undefined ? article.srsIntervalIndex : -1;
            }
        } catch (e) {
            console.error("Error fetching article for SRS:", e);
            return null;
        }
    } else {
        article = localData.articles.find(a => a.id === articleId);
        if (article) {
            currentIntervalIndex = article.srsIntervalIndex !== undefined ? article.srsIntervalIndex : -1;
        }
    }

    if (!article) return null;

    // Calculate next interval
    let nextIndex = currentIntervalIndex;
    if (accuracy >= 90) {
        nextIndex = Math.min(currentIntervalIndex + 1, SRS_INTERVALS.length - 1);
    } else {
        // If failed, reset to 0 or decrease? Let's reset to 0 for strict practice.
        nextIndex = 0;
    }

    const daysToAdd = SRS_INTERVALS[nextIndex];
    const nextReviewDate = new Date();
    nextReviewDate.setDate(nextReviewDate.getDate() + daysToAdd);

    const updateData = {
        srsIntervalIndex: nextIndex,
        nextReviewDate: user ? Timestamp.fromDate(nextReviewDate) : nextReviewDate.getTime(),
        lastReviewed: user ? Timestamp.now() : Date.now()
    };

    // Save update
    if (user) {
        try {
            await updateDoc(doc(db, 'artifacts', appId, 'users', user.uid, 'articles', articleId), updateData);
        } catch (e) {
            console.error("Error updating SRS (Cloud):", e);
        }
    } else {
        const updatedArticles = localData.articles.map(a => a.id === articleId ? { ...a, ...updateData } : a);
        saveLocalData({ ...localData, articles: updatedArticles });
    }

    return {
        message: accuracy >= 90 ? "記憶強化！" : "再接再厲",
        daysToAdd
    };
};
